// @ts-nocheck
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import iconXErase from "../../../../../../../assets/images/icon-x-erase.svg";
import aygLogo from "../../../../../../../assets/images/coronando-logo.svg";

const confirmModalCls = "";
const accentBarCls = "h-[3px] w-full bg-[linear-gradient(90deg,rgba(215,50,168,1)_0%,rgba(232,79,187,1)_100%)]";
const modalContentCls = "flex flex-col items-stretch pt-4 px-5 pb-5 h-full w-full box-border";
const contentAreaCls = "flex-1 flex flex-col gap-1.5 overflow-y-auto min-h-0 [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-white/20 [&::-webkit-scrollbar-thumb]:rounded";
const bottomButtonsCls = "flex flex-col gap-2 mt-4 pt-4 border-t border-[rgba(255,255,255,0.07)]";
const logoContainerCls = "flex justify-center";
const logoCls = "max-w-[var(--size-20)] h-auto";
const titleCls =
  "font-bold text-[clamp(0.875rem,2.5vw,1rem)] leading-snug text-center text-[var(--color-text)] mt-3 mb-3 px-2 w-full box-border";
const betsListCls = "flex flex-col w-full gap-1.5 m-0";
const betRowCls =
  "grid [grid-template-columns:28px_1fr_auto_auto_auto_auto] items-center gap-x-2 px-3 py-2.5 w-full box-border text-[var(--color-text-secondary)] text-(length:--font-body) leading-[1.4] bg-[rgba(255,255,255,0.04)] rounded-xl border border-[rgba(255,255,255,0.06)]";
const betRowNumberCls =
  "grid [grid-template-columns:1fr_auto_auto_auto] items-center gap-x-2 px-3 py-2.5 w-full box-border text-[var(--color-text-secondary)] text-(length:--font-body) leading-[1.4] bg-[rgba(255,255,255,0.04)] rounded-xl border border-[rgba(255,255,255,0.06)]";
const animalNumberCls = "font-semibold text-[var(--color-text)] text-xs leading-tight min-w-0";
const animalNameCls = "font-normal capitalize text-[var(--color-text-secondary)]";
const colorTextCls = "font-normal text-[var(--color-text-tertiary)]";
const amountCls = "font-bold text-[var(--color-primary)] text-xs whitespace-nowrap";
const timeCls = "font-normal text-[var(--color-text-tertiary)] text-(length:--font-caption)";
const deleteButtonCls =
  "w-6 h-6 min-w-[24px] border-0 bg-transparent cursor-pointer flex items-center justify-center rounded-full transition-colors duration-200 hover:bg-[rgba(215,50,168,0.15)] [&:hover_img]:opacity-100";
const deleteIconCls = "w-[13px] h-[13px] opacity-40 transition-opacity duration-200";
const navigationButtonsCls = "flex justify-between items-center w-full mt-2 gap-2";
const navButtonCls =
  "h-8 px-4 border border-[rgba(255,255,255,0.12)] bg-transparent text-xs font-semibold text-[var(--color-text-tertiary)] cursor-pointer rounded-full transition-all duration-200 hover:border-[var(--color-accent-magenta)] hover:text-[var(--color-accent-magenta)] disabled:opacity-25 disabled:cursor-not-allowed disabled:pointer-events-none";
const totalAmountCls =
  "flex justify-between items-center w-full mt-3 px-4 py-3 rounded-2xl bg-[rgba(253,238,51,0.05)] border border-[rgba(253,238,51,0.1)]";
const totalLabelCls = "text-[var(--color-text-secondary)] text-(length:--font-body) font-semibold";
const totalValueCls = "text-[var(--color-primary)] text-(length:--font-body-lg) font-extrabold";
const purchasedBetRowCls = "opacity-90";
const confirmBtnCls =
  "w-full h-12 rounded-full border-0 font-bold text-sm text-white cursor-pointer bg-[linear-gradient(135deg,rgba(232,79,187,1)_0%,rgba(215,50,168,1)_50%,rgba(180,30,155,1)_100%)] shadow-[0_4px_20px_rgba(215,50,168,0.5),inset_0_1px_0_rgba(255,255,255,0.15)] transition-[opacity,box-shadow] duration-200 hover:opacity-90 hover:shadow-[0_6px_28px_rgba(215,50,168,0.65)] active:scale-[0.98] disabled:opacity-40 disabled:cursor-not-allowed";
const backBtnCls =
  "w-full h-9 rounded-full border border-[rgba(255,255,255,0.12)] bg-transparent text-sm font-semibold text-[var(--color-text-tertiary)] cursor-pointer transition-all duration-200 hover:border-[rgba(255,255,255,0.25)] hover:text-[var(--color-text-secondary)] disabled:opacity-30";

const ConfirmTicketModal = ({
  visible,
  onClose,
  onCloseKeepBets, // New prop to close modal without clearing bets
  placedBets = [],
  totalAmount = 0,
  selectedTime,
  onConfirmPurchase,
  isPending = false,
  isSuccess = false,
  isError = false,
  onRemoveBet, // New prop to handle bet removal
  gameType, // 'numbers' or 'animals'
  gameName, // Added gameName prop
}) => {
  const [currentStep, setCurrentStep] = useState("confirm"); // "confirm", "success"
  const [currentPage, setCurrentPage] = useState(0);
  const betsPerPage = 10;

  const handleConfirm = e => {
    e.preventDefault();
    e.stopPropagation();
    onConfirmPurchase();
  };

  // Function to remove individual bets
  const handleRemoveBet = (betIndex, fichaIndex) => {
    if (onRemoveBet) {
      onRemoveBet(betIndex, fichaIndex);
    }
  };

  const totalPages = Math.ceil(placedBets.length / betsPerPage);
  const startIndex = currentPage * betsPerPage;
  const endIndex = startIndex + betsPerPage;
  const currentBets = placedBets.slice(startIndex, endIndex);

  const handleBack = () => {
    if (currentStep === "success") {
      // In success step, allow pagination but don't close modal
      if (currentPage > 0) {
        setCurrentPage(currentPage - 1);
      }
    } else if (currentStep === "confirm" && currentPage > 0) {
      setCurrentPage(currentPage - 1);
    } else {
      onClose();
    }
  };

  const handleNext = () => {
    if ((currentStep === "confirm" || currentStep === "success") && currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Reset step and page when modal opens/closes
  useEffect(() => {
    if (visible) {
      setCurrentStep("confirm");
      setCurrentPage(0);
    }
  }, [visible]);

  // Move to success step when purchase is successful
  useEffect(() => {
    if (isSuccess) {
      setCurrentStep("success");
    }
  }, [isSuccess]);

  // Return to confirm step if there's an error
  useEffect(() => {
    if (isError) {
      setCurrentStep("confirm");
    }
  }, [isError]);

  const getAnimalColor = animalId => {
    // Define which animals/bets are red or black
    const redAnimals = [
      "ROJO",
      "1",
      "3",
      "5",
      "7",
      "9",
      "12",
      "14",
      "16",
      "18",
      "19",
      "21",
      "23",
      "25",
      "27",
      "30",
      "32",
      "34",
      "36",
    ];
    const blackAnimals = [
      "NEGRO",
      "2",
      "4",
      "6",
      "8",
      "10",
      "11",
      "13",
      "15",
      "17",
      "20",
      "22",
      "24",
      "26",
      "28",
      "29",
      "31",
      "33",
      "35",
    ];

    const animalIdStr = String(animalId);
    if (redAnimals.includes(animalIdStr)) return "var(--color-roulette-red)";
    if (blackAnimals.includes(animalIdStr)) return "var(--color-roulette-black)";
    return "var(--color-roulette-green)"; // Green for special bets like PAR, IMPAR, etc.
  };

  if (!visible) return null;
  return (
    <div
      className={confirmModalCls}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: "var(--z-modal, 1000)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0,0.6)",
        backdropFilter: "blur(4px)",
      }}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        style={{
          width: 344,
          maxWidth: "calc(100vw - 32px)",
          maxHeight: "calc(100vh - 48px)",
          padding: 0,
          borderRadius: "var(--radius-xl)",
          height: 667,
          overflow: "hidden",
          background: "linear-gradient(160deg, var(--color-surface-2) 0%, var(--color-bg) 100%)",
          border: "1px solid rgba(215,50,168,0.25)",
          boxShadow: "0 24px 64px rgba(0,0,0,0.75), 0 0 0 1px rgba(255,255,255,0.04), 0 0 40px rgba(215,50,168,0.08), inset 0 1px 0 rgba(255,255,255,0.06)",
        }}
      >
        <div className={accentBarCls} />
        <div className={modalContentCls}>
          {/* AYG Logo */}
          <div className={logoContainerCls}>
            <img
              src={aygLogo}
              alt="AYG Logo"
              className={logoCls}
            />
          </div>

          {/* Title */}
          <h2 className={titleCls}>
            {currentStep === "success"
              ? "Gracias por jugar con nosotros. Mucha suerte"
              : "Confirma la compra de tu ticket"}
          </h2>

          {currentStep === "confirm" && (
            <>
              {/* Content Area - grows to fill available space */}
              <div className={contentAreaCls}>
                {/* Bets List */}
                <div className={betsListCls}>
                  {currentBets.map((bet, betIndex) => {
                    const color = getAnimalColor(bet.animalId);
                    const colorName =
                      color === "var(--color-roulette-red)"
                        ? "rojo"
                        : color === "var(--color-roulette-black)"
                          ? "negro"
                          : "verde";
                    const timeLabel = typeof selectedTime === "string" ? selectedTime.toLowerCase() : selectedTime;
                    const totalBetAmount = bet.fichas.reduce((sum, ficha) => sum + ficha.value, 0);
                    const amountLabel = `${totalBetAmount.toLocaleString("es-VE", {minimumFractionDigits: 2, maximumFractionDigits: 2})} Bs`;
                    return (
                      <div
                        // biome-ignore lint/suspicious/noArrayIndexKey: bets may repeat the same animalId; index disambiguates
                        key={`${bet.animalId}-${betIndex}`}
                        className={gameType === "numbers" ? betRowNumberCls : betRowCls}
                      >
                        {gameType === "numbers" ? (
                          <>
                            <span className={animalNumberCls}>
                              {bet.drawName || bet.drawTime || `${gameName} - ${timeLabel}`}
                            </span>
                            <span className={animalNameCls}>{bet.animalId}</span>
                            <span className={amountCls}>{amountLabel}</span>
                            <button
                              type="button"
                              className={deleteButtonCls}
                              onClick={() => handleRemoveBet(startIndex + betIndex, null)}
                              title="Eliminar apuesta"
                            >
                              <img
                                src={iconXErase}
                                alt="Eliminar"
                                className={deleteIconCls}
                              />
                            </button>
                          </>
                        ) : (
                          <>
                            <span className={animalNumberCls}>{bet.animalId}</span>
                            <span className={animalNameCls}>{bet.animalName}</span>
                            <span className={colorTextCls}>color {colorName}</span>
                            <span className={amountCls}>{amountLabel}</span>
                            <span className={timeCls}>{timeLabel}</span>
                            <button
                              type="button"
                              className={deleteButtonCls}
                              onClick={() => handleRemoveBet(startIndex + betIndex, null)}
                              title="Eliminar apuesta"
                            >
                              <img
                                src={iconXErase}
                                alt="Eliminar"
                                className={deleteIconCls}
                              />
                            </button>
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Navigation Buttons (paginate only) */}
                <div className={navigationButtonsCls}>
                  <button
                    type="button"
                    className={navButtonCls}
                    onClick={handleBack}
                    disabled={currentPage === 0}
                  >
                    {"< Atrás"}
                  </button>
                  <button
                    type="button"
                    className={navButtonCls}
                    onClick={handleNext}
                    disabled={placedBets.length === 0 || currentPage >= totalPages - 1}
                  >
                    {"Siguiente >"}
                  </button>
                </div>

                {/* Total Amount */}
                <div className={totalAmountCls}>
                  <span className={totalLabelCls}>Monto:</span>
                  <span className={totalValueCls}>{totalAmount.toFixed(2)} Bs</span>
                </div>
              </div>

              {/* Bottom Button Area - always at bottom */}
              <div className={bottomButtonsCls}>
                <button
                  type="button"
                  className={confirmBtnCls}
                  onClick={handleConfirm}
                  disabled={placedBets.length === 0 || isPending}
                >
                  {isPending ? "Comprando..." : "Comprar ticket"}
                </button>
                <button
                  type="button"
                  className={backBtnCls}
                  onClick={() => {
                    onCloseKeepBets ? onCloseKeepBets() : onClose();
                  }}
                >
                  Volver
                </button>
              </div>
            </>
          )}

          {currentStep === "success" && (
            <>
              {/* Content Area - grows to fill available space */}
              <div className={contentAreaCls}>
                {/* Show purchased bets with pagination */}
                <div className={betsListCls}>
                  {currentBets.map((bet, betIndex) => {
                    const color = getAnimalColor(bet.animalId);
                    const colorName =
                      color === "var(--color-roulette-red)"
                        ? "rojo"
                        : color === "var(--color-roulette-black)"
                          ? "negro"
                          : "verde";
                    const timeLabel = typeof selectedTime === "string" ? selectedTime.toLowerCase() : selectedTime;
                    const totalBetAmount = bet.fichas.reduce((sum, ficha) => sum + ficha.value, 0);
                    const amountLabel = `${totalBetAmount.toLocaleString("es-VE", {minimumFractionDigits: 2, maximumFractionDigits: 2})} Bs`;
                    if (gameType === "numbers") {
                      return (
                        <div
                          // biome-ignore lint/suspicious/noArrayIndexKey: bets may repeat the same animalId; index disambiguates
                          key={`success-${bet.animalId}-${betIndex}`}
                          className={`${betRowNumberCls} ${purchasedBetRowCls}`}
                        >
                          <span className={animalNumberCls}>{bet.drawName || bet.drawTime || "-"}</span>
                          <span className={animalNameCls}>{bet.animalId}</span>
                          <span className={amountCls}>{amountLabel}</span>
                          <span></span>
                        </div>
                      );
                    } else {
                      return (
                        <div
                          // biome-ignore lint/suspicious/noArrayIndexKey: bets may repeat the same animalId; index disambiguates
                          key={`success-${bet.animalId}-${betIndex}`}
                          className={`${betRowCls} ${purchasedBetRowCls}`}
                        >
                          <span className={animalNumberCls}>{bet.animalId}</span>
                          <span className={animalNameCls}>{bet.animalName}</span>
                          <span className={colorTextCls}>color {colorName}</span>
                          <span className={amountCls}>{amountLabel}</span>
                          <span className={timeCls}>{timeLabel}</span>
                          <span></span>
                        </div>
                      );
                    }
                  })}
                </div>

                {/* Navigation Buttons for success step */}
                {totalPages > 1 && (
                  <div className={navigationButtonsCls}>
                    <button
                      type="button"
                      className={navButtonCls}
                      onClick={handleBack}
                      disabled={currentPage === 0}
                    >
                      {"< Atrás"}
                    </button>
                    <button
                      type="button"
                      className={navButtonCls}
                      onClick={handleNext}
                      disabled={currentPage >= totalPages - 1}
                    >
                      {"Siguiente >"}
                    </button>
                  </div>
                )}

                {/* Total Amount */}
                <div className={totalAmountCls}>
                  <span className={totalLabelCls}>Total gastado:</span>
                  <span className={totalValueCls}>{totalAmount.toFixed(2)} Bs</span>
                </div>
              </div>

              {/* Bottom Button Area - always at bottom */}
              <div className={bottomButtonsCls}>
                <button
                  type="button"
                  className={backBtnCls}
                  onClick={() => {
                    setCurrentStep("confirm");
                    setCurrentPage(0);
                    onClose();
                  }}
                >
                  Volver
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

ConfirmTicketModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCloseKeepBets: PropTypes.func,
  placedBets: PropTypes.arrayOf(
    PropTypes.shape({
      animalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      animalName: PropTypes.string,
      fichas: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.number,
          name: PropTypes.string,
        })
      ),
    })
  ),
  totalAmount: PropTypes.number,
  selectedTime: PropTypes.string,
  onConfirmPurchase: PropTypes.func.isRequired,
  onRemoveBet: PropTypes.func,
  isPending: PropTypes.bool,
  isSuccess: PropTypes.bool,
  isError: PropTypes.bool,
  gameType: PropTypes.oneOf(["numbers", "animals"]), // New prop type
  gameName: PropTypes.string, // New prop type
};

export default ConfirmTicketModal;
